// Must stay in lockstep with the manager escalation template copy.
export const DAYS_OVERDUE_THRESHOLD = 5

export const WORKING_HOURS_PER_DAY = 8

export const ESCALATION_THRESHOLD_WORKING_HOURS = DAYS_OVERDUE_THRESHOLD * WORKING_HOURS_PER_DAY
